export default "__VITE_ASSET__DsUnS5oq__"